var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "#8BAA36",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAFAFA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M16.401 16.55v8.16-.161c0 2.283.997 4.306 2.542 5.614.755.64 1.254 1.504 1.254 2.463v13.352c0 1.484 1.276 2.688 2.848 2.688 1.571 0 2.847-1.204 2.847-2.688V32.626c0-.959.499-1.823 1.254-2.463 1.545-1.308 2.542-3.33 2.542-5.614V16.55v7.999M23.043 25.363V16.4M48.667 18.285c0-.99-.85-1.792-1.898-1.792H44.87c-3.145 0-5.694 2.407-5.694 5.378v10.755c0 2.338 1.588 4.308 3.796 5.048v8.304c0 1.484 1.275 2.689 2.847 2.689s2.847-1.205 2.847-2.69V18.286Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.4a38949525db6ce557ec87abe299b696.svg";
export { ForwardRef as ReactComponent };